import React, { useState } from 'react';
import styled from 'styled-components';
import MUITextField, { TextFieldProps } from '@material-ui/core/TextField';
import { Box, Typography } from '@material-ui/core';

interface IProps {
    error?: string;
    maxLength?: number;
    phone?: boolean;
}

const BaseTextField = ({
    defaultValue,
    error,
    maxLength,
    phone,
    value,
    ...other
}: Omit<TextFieldProps, 'error'> & IProps) => {
    const [shrinkLabel, setShrinkLabel] = useState(
        !!defaultValue || !!value || false
    );

    return (
        <>
            <MUITextField
                fullWidth
                defaultValue={defaultValue}
                error={!!error}
                InputLabelProps={{
                    shrink: !!value || shrinkLabel,
                }}
                inputProps={{
                    maxLength: maxLength,
                }}
                value={value}
                onBlur={() => {
                    if (!value) setShrinkLabel(false);
                }}
                onFocus={() => setShrinkLabel(true)}
                {...other}
            />
            <Box mt={2}>
                <Typography color="error">{error}</Typography>
            </Box>
        </>
    );
};

export const TextField = styled(BaseTextField)`
    .MuiInputBase-input {
        display: flex;
        align-items: center;
        min-height: 65px;
        background-color: ${({ theme }) => theme.palette.grey[50]};
        box-sizing: border-box;
        padding: 0;
        border-radius: 5px;
        padding-left: ${({ phone, theme, InputProps }) =>
            InputProps?.startAdornment
                ? phone
                    ? '5px'
                    : '14px'
                : `${theme.spacing(3)}px`};
        padding-right: ${({ theme, InputProps }) =>
            InputProps?.startAdornment ? '25px' : `${theme.spacing(3)}px`};
        padding-top: ${({ theme, InputProps }) =>
            InputProps?.startAdornment ? 0 : `${theme.spacing(4)}px`};
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
        color: ${({ theme }) => theme.palette.grey[900]};
        font-weight: 700;
    }

    .MuiFilledInput-root {
        border-radius: 5px;
        background-color: ${({ theme }) => theme.palette.grey[50]};

        .MuiInputAdornment-root .MuiSvgIcon-root {
            fill: ${({ theme }) => theme.palette.text.secondary};
        }

        &.Mui-focused {
            .MuiInputAdornment-root .MuiSvgIcon-root {
                fill: ${({ theme }) => theme.palette.primary.main};
            }
        }
    }

    .MuiInputLabel-filled {
        color: ${({ theme }) => theme.palette.grey[200]};
        transform: ${({ phone, InputProps }) =>
            `translate(${
                InputProps?.startAdornment ? (phone ? '80px' : '70px') : '14px'
            }, 24px) scale(1)`};

        &.MuiInputLabel-shrink {
            display: ${({ InputProps }) =>
                InputProps?.startAdornment ? 'none' : 'block'};
            transform: translate(14px, 10px) scale(0.75);
        }
    }

    .MuiFilledInput-underline:before,
    .MuiFilledInput-underline:after {
        display: none;
    }

    .MuiInputAdornment-root .MuiSvgIcon-root {
        position: relative;
        top: -1px;
        font-size: 1rem;
    }

    .MuiFilledInput-adornedStart {
        padding-left: 25px;
    }

    .MuiFilledInput-adornedStart {
        padding-left: 25px;
    }

    .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel) {
        margin-top: 0;
    }

    .Mui-disabled {
        color: ${({ theme }) => theme.palette.grey[400]};
    }
`;
